import LoadingButton from '@mui/lab/LoadingButton';
import { SxProps } from '@mui/material';
import { FC, ReactNode } from 'react';

interface LoadMoreButtonProps {
    children: ReactNode;
    loading: boolean;
    onClick: () => Promise<void> | void;
    sx?: SxProps;
}

const LoadMoreButton: FC<LoadMoreButtonProps> = ({ children, loading, onClick, sx }) => (
    <LoadingButton loading={loading} onClick={onClick} sx={sx} variant="outlined" fullWidth>
        {children}
    </LoadingButton>
);

export default LoadMoreButton;
